import { useState } from 'react';
import type { TabId } from './types';
import PortalSidebar from './components/PortalSidebar';
import PortalTopbar from './components/PortalTopbar';
import PortalPrehled from './components/tabs/PortalPrehled';
import PortalUlohy from './components/tabs/PortalUlohy';
import PortalSluzby from './components/tabs/PortalSluzby';
import PortalReporty from './components/tabs/PortalReporty';
import PortalFaktury from './components/tabs/PortalFaktury';
import PortalSpravy from './components/tabs/PortalSpravy';

const tabContent: Record<TabId, JSX.Element> = {
  prehled: <PortalPrehled />,
  ulohy: <PortalUlohy />,
  sluzby: <PortalSluzby />,
  reporty: <PortalReporty />,
  faktury: <PortalFaktury />,
  spravy: <PortalSpravy />,
};

export default function PortalPage() {
  const [activeTab, setActiveTab] = useState<TabId>('prehled');

  return (
    <div className="h-screen flex overflow-hidden bg-zinc-950">
      <title>Klientský portál | Boostio</title>

      {/* Sidebar */}
      <PortalSidebar activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <PortalTopbar activeTab={activeTab} />

        {/* Content */}
        <main className="flex-1 overflow-hidden">
          {tabContent[activeTab]}
        </main>
      </div>
    </div>
  );
}
